export default __webpack_public_path__ + "static/media/trailer-img.b681f67b.png";